<mat-progress-bar *ngIf="loading" class="progressBar__main" mode="determinate" [value]="value"></mat-progress-bar>
